import { Button, Space } from "antd";
import { useState } from "react";
import MessageIcon from "../../../assets/icons/MessageIcon";
import TitleBar from "../../../components/common/TitleBar";
import SidebarLayout from "../../../layouts/SidebarLayout";

const backLink = "/admin/organizations/list";

export default function OrganizationDetails() {
  const [tab, setTab] = useState("Profile");

  return (
    <SidebarLayout title="Organizations">
      <TitleBar title="JBS65342-XYZ Company" backLink={backLink} />
      <Space>
        {tabs.map((el) => (
          <Button
            key={el}
            onClick={() => setTab(el)}
            type={el === tab ? "primary" : "default"}
            className={
              el !== tab
                ? "!border-white !text-body-text font-medium"
                : "font-medium"
            }
            icon={el === "Message" ? <MessageIcon /> : null}
          >
            {el}
          </Button>
        ))}
      </Space>
    </SidebarLayout>
  );
}

const tabs = ["Profile", "Job’s Posts", "Active Project", "Payment", "Message"];
